import * as React from "react";
import { Tag } from "antd";
import { useNavigate } from "react-router-dom";
import { useCpFormValue } from "../../gvc/testNewForm/utils";
import { BasePathContext } from "../../../reactContexts/basePathContext";
import { FormLabel } from "../../../components/antd/form/FormLabel";
import { parseLink } from "../../../utils/linkParser/linkParser";

export const NGSSummary: React.FC = () => {
  const navigate = useNavigate();
  const basePath = React.useContext(BasePathContext);

  const isEnabled = useCpFormValue("ngs.isEnabled");
  const cloudAccount = useCpFormValue("ngs.cloudAccount");
  const pub = useCpFormValue("ngs.pub");
  const sub = useCpFormValue("ngs.sub");
  const resp = useCpFormValue("ngs.resp");
  const subs = useCpFormValue("ngs.subs");
  const data = useCpFormValue("ngs.data");
  const payload = useCpFormValue("ngs.payload");

  const ngsLogoPath = `/resources/logos/ngsLogo.svg`;

  function handleClickLogo() {
    navigate(`${basePath}/cloud-access-ngs`);
  }

  if (!isEnabled) {
    return (
      <button
        onClick={handleClickLogo}
        style={{
          width: "100%",
          height: 100,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          background: "var(--identity-ngs-logo-drop)",
          border: "1px solid var(--color-border)",
          borderRadius: "var(--border-radius)",
          cursor: "pointer",
          transition: "box-shadow var(--transition)",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)")}
        onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
      >
        <img src={ngsLogoPath} alt="NGS" style={{ height: 30 }} />
        <span style={{ fontWeight: 600, color: "var(--color-default)" }}>NGS</span>
      </button>
    );
  }

  const caName = cloudAccount.value || parseLink(cloudAccount.link, { useInputCtx: true }).name;

  const renderTags = (items: any[]) => {
    if (!items || items.length === 0) return <span style={{ color: "var(--color-label)" }}>Not Set</span>;
    return (
      <div className="flex flex-wrap gap-1">
        {items.map((item: any, i: number) => (
          <Tag key={i}>{item.value}</Tag>
        ))}
      </div>
    );
  };

  const renderValue = (value: string | undefined) => {
    if (value === undefined || value === "") return <span style={{ color: "var(--color-label)" }}>Not Set</span>;
    return <span>{value}</span>;
  };

  return (
    <div
      style={{
        border: "1px solid var(--color-border)",
        borderRadius: "var(--border-radius)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          padding: "16px 20px",
          borderBottom: "4px solid var(--identity-ngs-logo-accent)",
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}
      >
        <img src={ngsLogoPath} alt="NGS" style={{ height: 30 }} />
        <span style={{ fontWeight: 600 }}>NGS</span>
      </div>

      <div style={{ padding: "20px" }}>
        <div className="mb-4">
          <FormLabel>Cloud Account</FormLabel>
          {cloudAccount.link ? (
            <a
              href={`/console${cloudAccount.link}`}
              onClick={(e) => {
                e.preventDefault();
                navigate(`/console${cloudAccount.link}`);
              }}
              className="color-link"
            >
              {caName}
            </a>
          ) : (
            <div>{caName}</div>
          )}
        </div>

        <div className="flex mb-4">
          <div style={{ width: "50%" }}>
            <FormLabel>Pub Allow</FormLabel>
            {renderTags(pub.allow)}
          </div>
          <div style={{ width: "50%" }}>
            <FormLabel>Pub Deny</FormLabel>
            {renderTags(pub.deny)}
          </div>
        </div>

        <div className="flex mb-4">
          <div style={{ width: "50%" }}>
            <FormLabel>Sub Allow</FormLabel>
            {renderTags(sub.allow)}
          </div>
          <div style={{ width: "50%" }}>
            <FormLabel>Sub Deny</FormLabel>
            {renderTags(sub.deny)}
          </div>
        </div>

        <div className="flex mb-4">
          <div style={{ width: "33.33%" }}>
            <FormLabel>Resp Max</FormLabel>
            {renderValue(resp.max)}
          </div>
          <div style={{ width: "33.33%" }}>
            <FormLabel>Resp TTL</FormLabel>
            {renderValue(resp.ttl)}
          </div>
          <div style={{ width: "33.33%" }}>
            <FormLabel>Subs</FormLabel>
            {renderValue(subs)}
          </div>
        </div>

        <div className="flex mb-4">
          <div style={{ width: "33.33%" }}>
            <FormLabel>Data</FormLabel>
            {renderValue(data)}
          </div>
          <div style={{ width: "33.33%" }}>
            <FormLabel>Payload</FormLabel>
            {renderValue(payload)}
          </div>
        </div>

        <div className="flex justify-end mt-4">
          <a
            onClick={(e) => {
              e.preventDefault();
              navigate(`${basePath}/cloud-access-ngs`);
            }}
            className="color-link"
            style={{ cursor: "pointer", fontWeight: 500 }}
          >
            Details →
          </a>
        </div>
      </div>
    </div>
  );
};
